import { VWTheme } from "./VWTheme";
import globalGUIConfig from "../common/VWGui.json";
import themeConfig from "./themes.json";

const GUI = globalGUIConfig.GUI;

export class VWThemeUtils {
    private constructor() {}

    public static adjustComponentsToCurrentTheme(): void {
        const currentTheme: VWTheme = localStorage.getItem("theme") as VWTheme ?? VWTheme.DARK;

        VWThemeUtils.adjustComponentsToTheme(currentTheme);
    }

    public static adjustComponentsToTheme(theme?: VWTheme): void {
        const themeToUse: VWTheme = theme ?? (localStorage.getItem("theme") as VWTheme ?? VWTheme.DARK);
        const idsForReference: string[] = themeConfig.IDs;
        const classesForReference: string[] = themeConfig.Classes;

        VWThemeUtils.adjustBodyClassesToTheme(themeToUse);

        idsForReference.forEach((id: string) => VWThemeUtils.adjustElementClassesToThemeByID(id, themeToUse, id));
        classesForReference.forEach((classReference: string) => VWThemeUtils.adjustElementClassesToThemeByClass(classReference, themeToUse, classReference));

        VWThemeUtils.adjustToggleThemeButtonToTheme(themeToUse);
    }

    private static adjustBodyClassesToTheme(theme: VWTheme): void {
        const bodyReference: string = themeConfig.Body[0];

        VWThemeUtils.adjustElementClassesToTheme(document.body, theme, bodyReference);
    }

    private static adjustElementClassesToThemeByID(elementID: string, theme: VWTheme, referenceID: string): void {
        VWThemeUtils.adjustElementClassesToTheme(document.getElementById(elementID), theme, referenceID);
    }

    private static adjustElementClassesToThemeByClass(elementClass: string, theme: VWTheme, referenceClass: string): void {
        document.querySelectorAll(`.${elementClass}`).forEach((element: Element) => {
            VWThemeUtils.adjustElementClassesToTheme(element, theme, referenceClass);
        });
    }

    private static getClassForTheme(theme: VWTheme, reference: string): string {
        if (theme === VWTheme.DARK) {
            return `${reference}-dark`
        }
        else if (theme === VWTheme.LIGHT) {
            return `${reference}-light`
        }
        else {
            throw new Error("The theme is not supported.");
        }
    }

    private static adjustElementClassesToTheme(element: Element, theme: VWTheme, reference: string): void {
        const themeClassesPrefix: string = `${reference}-`;
        const classForTheme: string = VWThemeUtils.getClassForTheme(theme, reference);

        element?.classList.forEach((elementClass: string) => {
            if (elementClass.startsWith(themeClassesPrefix)) {
                element.classList.remove(elementClass);
            }
        });

        element?.classList.add(classForTheme);
    }

    private static adjustToggleThemeButtonToTheme(theme: VWTheme): void {
        const toggleThemeButton: HTMLButtonElement = document.getElementById(GUI.ToggleThemeDiv.ToggleThemeButton.ID) as HTMLButtonElement;

        toggleThemeButton.textContent = theme === VWTheme.LIGHT ? GUI.ToggleThemeDiv.ToggleThemeButton.TextLight : GUI.ToggleThemeDiv.ToggleThemeButton.TextDark;
    }
}
